module.exports = __webpack_public_path__ + "public-ui/img/file-blue.9ab04a94.svg";